import { render, staticRenderFns } from "./EventManage.vue?vue&type=template&id=7866c4f0&"
import script from "./EventManage.vue?vue&type=script&lang=js&"
export * from "./EventManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports